import { useEffect, useState } from "react";
import { Coins } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel, Spinner } from "@/components/common";

export default function BookingValues() {
  const [v, setV] = useState(null);
  const [val, setVal] = useState("");
  useEffect(() => { api.get("/values/settings").then((r) => { setV(r.data); setVal(r.data.booked); }).catch(() => setV({ booked: 280, package_presets: [] })); }, []);
  const save = async () => {
    try { const { data } = await api.put("/values/settings", { booked: Number(val) }); setV(data); toast.success("Default booked value saved"); } catch (e) { toast.error(errMsg(e)); }
  };
  const propose = async () => {
    try { await api.post("/proposals/package-action"); toast.success("'Package closed' action proposal added to Approvals"); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!v) return <Spinner />;
  return (
    <Panel title="Booking values" icon={Coins} testid="booking-values-panel">
      <p className="mb-4 text-sm text-slate-400">Booked leads are sent to Google Ads with this value (first session), editable per lead in the Lead inbox. Closed packages ({v.package_presets.map((p) => `S$${p.toLocaleString()}`).join(" / ")} or custom) go to a separate, report-only "Package closed" action, so bidding doesn't change.</p>
      <div className="flex flex-wrap items-center gap-4 text-sm text-slate-300">
        <label className="flex items-center gap-2">Booked assessment S$ <input data-testid="booked-default-input" type="number" min="0" className="cc-input w-24 px-2 py-1" value={val} onChange={(e) => setVal(e.target.value)} /></label>
        <button data-testid="booked-default-save" onClick={save} disabled={Number(val) === v.booked} className="cc-btn cc-btn-ghost px-3 py-1.5 text-xs">Save</button>
        <button data-testid="propose-package-action-btn" onClick={propose} className="cc-btn cc-btn-ghost px-3 py-1.5 text-xs">Propose: create "Package closed" action</button>
      </div>
    </Panel>
  );
}
